import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import { useTran } from "@/hooks";

const CompanyActions = ({ company, onEdit, onDelete, disabled }) => {
  const { t } = useTran();
  const companyId = company?.id ?? company?._id ?? company?.companyId ?? null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t("Actions")}
          disabled={disabled}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel>{t("Actions")}</DropdownMenuLabel>
        <DropdownMenuItem
          onSelect={() => {
            if (!companyId || disabled) return;
            onEdit?.(company);
          }}
          className="gap-2"
        >
          <Pencil className="h-4 w-4 text-blue-600" />
          {t("Edit")}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => {
            if (!companyId || disabled) return;
            onDelete?.(company);
          }}
          className="gap-2"
          variant="destructive"
        >
          <Trash2 className="h-4 w-4" />
          {t("Delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CompanyActions;
